import React from 'react';
import companyInfo from '../../../themes/themes';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import EmailSupport from '../../BuildingBlocks/Misc/EmailSupport';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(2),
  },
  nextButton: {
    minWidth: 200,
    fontSize: '1.2em',
  },
  email: { marginTop: theme.spacing(1) },
}));

export default function PlanDiscoveryDialog({
  goForward,
  activeStep,
  numPages,
  close,
}) {
  const classes = useStyles({ activeStep });

  const theme = process.env.REACT_APP_THEME;

  return (
    <div className={classes.root}>
      <Button
        color="primary"
        variant="contained"
        endIcon={activeStep === numPages ? null : <KeyboardArrowRightIcon />}
        id="plan-discovery-next"
        className={classes.nextButton}
        onClick={() => {
          if (activeStep < numPages) {
            goForward();
          } else {
            close(true);
          }
        }}
      >
        {activeStep === 1 && 'Projections'}
        {activeStep === 2 && 'Growth Capital'}
        {activeStep === 3 && "What's the bottom line?"}
        {activeStep === 4 && "I'm in! Now what?"}
      </Button>
      {activeStep === 4 && (
        <div className={classes.email}>
          <EmailSupport
            inheritColor={true}
            text={'Contact ' + companyInfo[theme]?.company}
          />
        </div>
      )}
    </div>
  );
}
